import * as PopupEditor from '@bingads-webui/popup-editor';

export function InlineEditableColumnPrompt({
  position, item, i18n, fieldName, customValidators = null, schema, saveModel,
}) {
  PopupEditor.prompt({
    position,
    i18n,
    schema,
    model: item,
    fields: [fieldName],
    hasLabels: false,
    template: 'inline',
    customValidators,
    saveModel,
    parentContainerSelector: '.grid-and-disclaim-container',
  });
}
